// @flow
type LinkData = {
  filename: string,
  blob: Blob,
  type: string
}

type CSVData = {
  filename: string,
  file: Blob
}

type PDFData = {
  filename: string;
  file: any
}
type ZipData = {
  filename: string;
  file: any
}

export const defaultError: string = 'Não foi possível realizar o processo, tente novamente mais tarde';

export function getBlobError(err: Object, message: string = defaultError): any {
  if (err && err.data) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.addEventListener('abort', reject);
      reader.addEventListener('error', reject);
      reader.addEventListener('loadend', () => {
        const result = JSON.stringify(reader.result);
        const parsedResult = JSON.parse(result);
        resolve(parsedResult);
      });
      reader.readAsText(err.data);
    });
  }
  return { message };
}

export function createLink({ filename, blob, type = 'application/pdf' }: LinkData) {
  const blobPdf = new Blob([blob], { type });

  const { msSaveOrOpenBlob } = window.navigator;

  if (msSaveOrOpenBlob) {
    return msSaveOrOpenBlob(blobPdf, filename);
  }
  return window.URL.createObjectURL(blobPdf);
}

const { body } = document;
export function downloadCsvFile({ filename, file }: CSVData) {
  if (!body) throw new Error('Unexpectedly missing <body>.');
  const url = createLink({ filename, blob: file, type: 'application/csv' });

  if (window.navigator.msSaveOrOpenBlob) {
    window.open(url);
  }
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${filename}.csv`);

  body.appendChild(link);
  link.click();
  body.removeChild(link);
}
export function downloadXlsFile({ filename, file }: CSVData) {
  if (!body) throw new Error('Unexpectedly missing <body>.');
  const url = createLink({ filename, blob: file, type: 'application/octet-stream' });

  if (window.navigator.msSaveOrOpenBlob) {
    window.open(url);
  }
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${filename}.xlsx`);

  body.appendChild(link);
  link.click();
  body.removeChild(link);
}

export function downloadPDFFile({ filename, file }: PDFData) {
  if (!body) throw new Error('Unexpectedly missing <body>.');
  const url = createLink({ filename, blob: file, type: 'application/pdf' });

  if (window.navigator.msSaveOrOpenBlob) {
    window.open(url);
  }
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${filename}.pdf`);

  body.appendChild(link);
  link.click();
  body.removeChild(link);
}

export function downloadZipFile({ filename, file }: ZipData) {
  if (!body) throw new Error('Unexpectedly missing <body>.');
  const url = createLink({ filename, blob: file, type: 'application/zip' });

  console.log(file, 'blob');

  if (window.navigator.msSaveOrOpenBlob) {
    window.open(url);
  }
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${filename}.zip`);

  body.appendChild(link);
  link.click();
  body.removeChild(link);
}
